import script from "./RecurringPayments.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecurringPayments.vue?vue&type=script&setup=true&lang=ts"

import "./RecurringPayments.vue?vue&type=style&index=0&id=fc53effa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc53effa"]])

export default __exports__